// extracted by mini-css-extract-plugin
export var $animation_name = "Spacing-module--$animation_name--4ac16";
export var spacing = "Spacing-module--spacing--20a2e";
export var spacing__100px = "Spacing-module--spacing__100px--51632";
export var spacing__140px = "Spacing-module--spacing__140px--28df2";
export var spacing__180px = "Spacing-module--spacing__180px--0cb5d";
export var spacing__20px = "Spacing-module--spacing__20px--0d7d2";
export var spacing__40px = "Spacing-module--spacing__40px--e8f6b";
export var spacing__72px = "Spacing-module--spacing__72px--404a3";
export var spacing__desktopOnly = "Spacing-module--spacing__desktopOnly--a4eb4";
export var spacing__mobileOnly = "Spacing-module--spacing__mobileOnly--f1fdb";